import React from 'react';
import { useTheme } from '../../contexts/ThemeContext';

const TypeArticleCardSelect = ({ groupedTypes, selectedTypeId, onSelect }) => {
  const { isDarkMode } = useTheme();
  return (
    <div className="flex flex-col gap-6">
      {Object.entries(groupedTypes).map(([famille, types]) => (
        <div key={famille}>
          <div className="font-bold text-lg mb-2 mt-2 text-primary-600 dark:text-primary-400">{famille}</div>
          <div className="flex flex-wrap gap-3">
            {types.map(type => (
              <button
                key={type.id}
                type="button"
                className={`min-w-[140px] max-w-xs flex-1 px-4 py-3 rounded-xl border transition-all shadow-sm text-left
                  ${selectedTypeId === type.id
                    ? 'border-primary-600 bg-primary-50 dark:bg-primary-900 dark:border-primary-400 text-primary-700 dark:text-primary-200'
                    : isDarkMode
                      ? 'border-gray-700 bg-gray-800 text-white hover:border-primary-600'
                      : 'border-gray-300 bg-white text-gray-900 hover:border-primary-500'}
                `}
                onClick={() => onSelect(type.id)}
              >
                <div className="font-semibold text-base mb-1">{type.designation}</div>
                {/* image removed as requested */}
                {/* Optionally show famille name or id if needed */}
              </button>
            ))}
          </div>
        </div>
      ))}
    </div>
  );
};

export default TypeArticleCardSelect;
